import { minusIcon } from '../../../assets/svg/minuseIcon';
import { plusIcon } from '../../../assets/svg/plusIcon';
import { getStyle } from '../../../helper/getStyle';
import { Button } from '../../Button/Button';
import Dental from '../../../../entities/ServicesComponents/Dental';
import styles from './AccordionItem.module.scss'

const AccordionItem = ({
    element,
    onClick,
    isOpen,
    className
  

}) => { 

    return (
        <li className={getStyle(styles.list, {}, [className])}>
            <Button
                className={isOpen ? styles.open : styles.question}
                onClick={onClick}
            >
                {element.name} {isOpen ? minusIcon() : plusIcon()}
            </Button>
            {
                isOpen &&
                <div className={styles.answer}>
                    {
                        element.services.map(dent => <Dental key={dent.id} dent={dent}/>)
        }
                </div>
            }

        </li>
    );
}

export default AccordionItem;